const PROD_HOST = 'qic.online';

function isProdHost(host: string): boolean {
  return host === PROD_HOST || host.endsWith(`.${PROD_HOST}`);
}

// TODO: remove after vault integration
export function getRecaptchaKey(): string | undefined {
  const host
    = typeof window !== 'undefined'
      ? window.location.hostname
      : '';

  return isProdHost(host)
    ? import.meta.env.VUE_APP_RECAPTCHA_KEY
    : import.meta.env.VUE_APP_RECAPTCHA_KEY_DEV;
}
